import '../styles/components/filter/filter.less'

import { on } from '@/lib/dom/on'
import { ready } from '@/lib/ready'
import { getUrlParameter, onlyNumber } from '@/lib/utils'
import easyDialog from '@/lib/easy-dialog'
import { addClass } from '@/lib/dom/addClass'
import { removeClass } from '@/lib/dom/removeClass'
import { trigger } from '@/lib/dom/trigger'
import { hasClass } from '@/lib/dom/hasClass'
import { hideElement } from '@/lib/dom/hideElement'
import { nextAll } from '@/lib/dom/nextAll'
import { showElement } from '@/lib/dom/showElement'

ready(() => {
  const searchGO = document.querySelector<HTMLElement>('#searchGO')
  if (searchGO) {
    on(searchGO, 'click', () => {
      const input = document.querySelector('#f-search') as HTMLInputElement
      const terms = input.value.trim()
      if (terms == '') return

      const baseurl = searchGO.dataset['uri']!
      const connector = baseurl.lastIndexOf('?') != -1 ? '&' : '?'
      let within = getUrlParameter('searchwithin')
      within = within != null ? within + ',' + terms : terms
      window.location.href = baseurl + connector + 'searchwithin=' + encodeURIComponent(within)
    })
  }
})

ready(() => {
  const superrushGO = document.querySelector<HTMLElement>('#superrushGO')
  const superRush = document.querySelector('#f-super-rush') as HTMLElement
  if (superRush) {
    on(superRush, 'input', (e: MouseEvent) => {
      const target = e.target as HTMLInputElement
      target.value = onlyNumber(target.value)
    })

    on(superRush, 'keyup', (event: KeyboardEvent) => {
      if (event.code == 'Enter' || event.code == 'NumpadEnter') {
        if (superrushGO) {
          trigger(superrushGO, 'click')
        }
      }
    })
  }

  if (superrushGO) {
    on(superrushGO, 'click', () => {
      const input = document.querySelector('#f-super-rush') as HTMLInputElement
      const zip = input.value.trim()
      if (zip.length != 5) {
        alert('Please enter a valid postcode')
      } else {
        const baseurl = superrushGO.dataset['uri']!
        const ph = superrushGO.dataset['ph']!
        fetch('/ajax/ZipCode.ashx?action=checkZip&zip=' + zip, {})
          .then((res) => res.json())
          .then((json) => {
            if (json.Code == 1) {
              window.location.href = baseurl.replace(ph, zip)
            } else {
              alert('Please enter a valid postcode')
            }
          })
      }
    })
  }
})

ready(() => {
  const el = document.querySelector<HTMLElement>('.a_super-rush')
  if (el) {
    on(el, 'click', () => {
      easyDialog.open({
        container: {
          header: 'Super Rush',
          content:
            '<div class="super-rush-notes"><style>.easyDialog_wrapper .easyDialog_text{padding:15px 0;}.easyDialog_wrapper .easyDialog_title { background: #fff;border: 0;}.easyDialog_wrapper .easyDialog_content {border-radius: 0;}.super-rush-notes {overflow-y: scroll;height: auto;min-height: 400px;max-height: 600px;}@media (max-width: 768px) {.super-rush-notes {max-height: calc(100vh - 65px);}}</style><iframe src="/super-rush?view=1" id="IframeSuperRush" scrolling="no" style="width:100%; min-height:400px;" frameborder="0"></iframe></div>'
        },
        drag: true,
        autoClose: 0
      })
      // $('#easyDialogBox').css('z-index', '10004');
      const easyDialogBox = document.getElementById('easyDialogBox')
      if (easyDialogBox) {
        easyDialogBox.style.zIndex = '10004'
      }
    })
  }
})

ready(() => {
  // 按控件类型分别绑定: 原先用 querySelector 只取到页面上第一个 .go,
  // Dimensions 的 GO 排在 Price Range 之后, 会绑不上
  on('.new_search_price .go', 'click', (e: MouseEvent) => {
    const par = (e.currentTarget as HTMLElement).closest<HTMLElement>('.leftfilter-item-control')!
    NewActionPriceRange(par)
  })

  on('.new_search_dimension .go', 'click', (e: MouseEvent) => {
    const par = (e.currentTarget as HTMLElement).closest<HTMLElement>('.leftfilter-item-control')!
    NewActionDimension(par)
  })

  // 把 Height/Width/Depth/Diameter 的输入拼成 h5-w10 这样的尺寸串, 填进 data-uri 的占位符
  function NewActionDimension(par: HTMLElement) {
    const baseurl = par.dataset['uri']!
    const ph = par.dataset['ph']!
    const parts: string[] = []

    par.querySelectorAll<HTMLInputElement>('.dimension-size').forEach((input) => {
      const key = input.dataset['dimension']
      const size = parseFloat(input.value.trim())
      if (!key || isNaN(size) || size <= 0) return
      parts.push(key + parseFloat(size.toFixed(2)))
    })

    window.location.href = baseurl.replace(ph, parts.join('-'))
  }

  function NewActionPriceRange(par: HTMLElement) {
    const baseurl = par.dataset['uri']!
    const priceMinEl = par.querySelector<HTMLInputElement>('.price-min')!
    const priceMaxEl = par.querySelector<HTMLInputElement>('.price-max')!

    let min = parseFloat(priceMinEl.value.trim())
    let max = parseFloat(priceMaxEl.value.trim())

    const minStr = isNaN(min) ? '' : parseFloat(min.toFixed(2)).toString()
    const maxStr = isNaN(max) ? '' : parseFloat(max.toFixed(2)).toString()
    if (minStr != '' && maxStr != '') {
      const a = Math.min(min, max),
        b = Math.max(min, max)
      ;(min = a), (max = b)
    }
    const ph = par.dataset['ph']!
    let fil = ''
    if (minStr != '' || maxStr != '') {
      let param = min + '-' + max
      if (minStr == '') param = 'under-' + maxStr
      else if (maxStr == '') param = 'over-' + minStr
      fil = param
    }
    window.location.href = baseurl.replace(ph, fil)
  }
})

/*
 * left filter
 */
ready(() => {
  on('.leftfilter-seemore', 'click', (event: MouseEvent) => {
    const target = event.target as HTMLElement
    if (target) {
      addClass(target.parentElement!, 'is-all')
    }
  })
  on('.leftfilter-seefewer', 'click', (event: MouseEvent) => {
    const target = event.target as HTMLElement
    if (target) {
      removeClass(target.parentElement!, 'is-all')
    }
  })

  document.querySelectorAll('.leftfilter-type').forEach((el) => {
    const btn = el.querySelector<HTMLElement>('.leftfilter-show')
    if (btn) {
      on(btn, 'click', () => {
        if (hasClass(btn, 'leftfilter-show')) {
          btn.setAttribute('class', 'leftfilter-hide')

          nextAll(btn.parentElement!, '.leftfilter-list,.leftfilter-item').forEach((el) => {
            // el.setAttribute('class','leftfilter-type')
            hideElement(el)
          })
        } else {
          btn.setAttribute('class', 'leftfilter-show')
          nextAll(btn.parentElement!, '.leftfilter-list,.leftfilter-item').forEach((el) => {
            let isHideend = false
            if (hasClass(el, 'hidden')) {
              isHideend = true
            }
            if (hasClass(el, 'leftfilter-seemore')) {
              if (!isHideend) {
                showElement(el)
              }
            } else if (hasClass(el, 'leftfilter-seefewer')) {
              if (!isHideend) {
                showElement(el)
              }
            } else {
              showElement(el)
            }
          })
        }
      })
    }
  })

  //@ts-ignore
  if (window._leftmenu_completed === 'B') {
    trigger(document.querySelector('.leftfilter-title .leftfilter-show'), 'click')
  }

  if (document.querySelector('.leftfilter-title[data-p="p-title-locationnames"]')) {
    const el = document.querySelector('.leftfilter-title[data-p="p-title-locationnames"]')!

    el.nextElementSibling!.querySelectorAll<HTMLInputElement>('.ckb_label').forEach((el, index) => {
      const imgpath = el.parentElement!.dataset['img']!
      if (imgpath != '') {
        // $(this).mouseover(function () {
        //   $(this).after('<div style="position: absolute;z-index: 1000; top:25px; left:30px;"><img src="' + imgpath + '" alt="' + imgpath + '" /></div>');
        // }).mouseout(function () {
        //   $(this).nextAll().remove();
        // });
        on(el, 'mouseover', () => {
          const div = document.createElement('div')
          div.style.position = 'absolute'
          div.style.zIndex = '1000'
          div.style.top = '25px'
          div.style.left = '30px'
          div.innerHTML = `<img src="${imgpath}" alt="${imgpath}" />`
          el.insertAdjacentElement('afterend', div)
        })
        on(el, 'mouseout', () => {
          el.nextElementSibling!.remove()
        })
      }
    })
  }
})

ready(() => {
  const el = document.querySelector<HTMLInputElement>('#f-search')
  if (el) {
    on(el, 'keyup', (event: KeyboardEvent) => {
      if (event.code == 'Enter' || event.code == 'NumpadEnter') {
        trigger(document.querySelector('#searchGO'), 'click')
        return
      }
    })
  }
})

ready(() => {
  on('.leftfilter-item .price-min,.leftfilter-item .price-max,.leftfilter-item .dimension-size', 'keyup', (e: KeyboardEvent) => {
    const target = e.target as HTMLInputElement
    if (e.code == 'Enter' || e.code == 'NumpadEnter') {
      const par = target.closest('.leftfilter-item-control')!
      if (par) {
        trigger(par.querySelector('.go'), 'click')
      }
      return
    }
  })

  on('.ckb_label', 'click', (event: MouseEvent) => {
    const target = event.target as HTMLElement
    if (target.previousElementSibling) {
      const prev = target.previousElementSibling as HTMLInputElement
      if (!prev.disabled) {
        if (prev.checked) {
          prev.removeAttribute('checked')
        } else {
          prev.setAttribute('checked', 'checked')
        }
      }
    }
  })
})

ready(() => {
  on('.leftfilter-master .check-filter', 'click', (event: MouseEvent) => {
    const target = event.target as HTMLElement
    window.location.href = target.nextElementSibling!.querySelector('a')!.getAttribute('href')!
  })

  on('#checkPreProduction', 'click', (event: MouseEvent) => {
    const target = event.target as HTMLElement
    window.location.href = target.nextElementSibling!.querySelector('a')!.getAttribute('href')!
  })
})
